import { useMemo } from 'react';

import { ADD_CATEGORY_LABEL, TABLET } from '@app/constants';
import { useNewUserAccessRights, useWindowSize } from '@app/hooks';

export const useServiceCategoriesHeader = () => {
  const { innerWidth, isMobile } = useWindowSize();
  const {
    userAccessRights: { ClientServices },
  } = useNewUserAccessRights();

  const hasUserRightCreateCategory = useMemo(
    () => ClientServices?.IsCategoryCreate,
    [ClientServices]
  );

  const label = useMemo(
    () => (innerWidth <= TABLET ? '' : ADD_CATEGORY_LABEL),
    [innerWidth]
  );

  return { hasUserRightCreateCategory, label, isMobile };
};
